var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 76,
    height: 76,
    rx: 38,
    stroke: "#F9FAFB",
    strokeWidth: 11.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.665 50.3333L43.9984 44M43.9984 44L50.3317 50.3333M43.9984 44V58.25M56.665 51.5095C58.5991 49.9122 59.8317 47.4959 59.8317 44.7917C59.8317 39.9822 55.9329 36.0833 51.1234 36.0833C50.7774 36.0833 50.4537 35.9028 50.2781 35.6048C48.2133 32.101 44.4012 29.75 40.04 29.75C33.4817 29.75 28.165 35.0666 28.165 41.625C28.165 44.8963 29.4878 47.8587 31.6277 50.0064",
    stroke: "#475467",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.d36c0796f158b215401a7153c74d9f12.svg";
export { ForwardRef as ReactComponent };